function ManagerHierarchy({ employee }) {
  console.log("employee----------", employee);

  return <>ManagerHierarchy</>;
}

export default ManagerHierarchy;
